module.exports = __webpack_public_path__ + "static/qr-menu-sample-bc407428fd50c037cb71b8de5379543c.jpg";